import { DocumentProps, pdf } from '@react-pdf/renderer';

import React from 'react';

type PopupOptions = {
  width: number;
  height: number;
  resizable?: boolean;
  scrollbars?: boolean;
};

type PopupSettings = boolean | PopupOptions;

export interface PrintOptions {
  printDialog: boolean;
  popup: PopupSettings;
}

const defaultPopupOptions: PopupOptions = {
  width: 1200,
  height: 800,
  scrollbars: true,
  resizable: true,
};

export async function documentPdf(
  doc: React.ReactElement<DocumentProps>,
  options: Partial<PrintOptions> = {},
): Promise<void> {
  const pdfBlob = await pdf(doc).toBlob();
  const url = URL.createObjectURL(pdfBlob);

  const { printDialog = false, popup = false } = options;

  // Open the generated PDF in a new tab or popup window
  let pdfWindow: Window | null = null;

  if (!popup) {
    pdfWindow = window.open(url, '_blank');
  } else {
    const config: PopupOptions = popup === true ? defaultPopupOptions : popup;
    const { width, height, resizable = true, scrollbars = true } = config;

    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;

    pdfWindow = window.open(
      url,
      '',
      `width=${width},height=${height},resizable=${
        resizable ? 'yes' : 'no'
      },scrollbars=${scrollbars ? 'yes' : 'no'},top=${top},left=${left}`,
    );
  }

  if (pdfWindow !== null && printDialog) {
    pdfWindow.onload = () => {
      if (pdfWindow) {
        pdfWindow.print();
      }
    };
  }

  // Clean up the object URL after a short delay
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
